import { render, staticRenderFns } from "./sectorSetup.vue?vue&type=template&id=7909db3e&scoped=true&"
import script from "./sectorSetup.vue?vue&type=script&lang=js&"
export * from "./sectorSetup.vue?vue&type=script&lang=js&"
import style0 from "./sectorSetup.vue?vue&type=style&index=0&id=7909db3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7909db3e",
  null
  
)

export default component.exports